import React from 'react';
import { string, number, object } from 'prop-types';
import { I18nProvider } from '@fiverr-private/fiverr_context';
import LazyImage from '../LazyImage';

const MAX_IMAGES_IN_VIEWPORT = 3;

// pos is a non-zero based index

const TouchImage = ({ subCategoryNameKey, image, pos }) => (
    <I18nProvider>
        {({ i18n }) => {
            if (pos <= MAX_IMAGES_IN_VIEWPORT) {
                return (
                    <img alt={i18n.t(subCategoryNameKey)} src={image.touchSrc} srcSet={image.touchSrcSet}/>
                );
            } else {
                return (
                    <LazyImage alt={i18n.t(subCategoryNameKey)} src={image.touchSrc} srcSet={image.touchSrcSet}/>
                );
            }
        }}
    </I18nProvider>
);

TouchImage.propTypes = {
    subCategoryNameKey: string,
    image: object,
    pos: number
};

export default TouchImage;
